module.exports = __webpack_public_path__ + "img/5.992fd46f.jpg";